import gsap from "gsap";

export const footerImagesReveal = () => {
  const footer = document.getElementById("home-footer");
  if (!footer) return;

  const targets = Array.from(
    footer.querySelectorAll<HTMLElement>("[data-footer-reveal-target]"),
  );
  if (targets.length === 0) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (prefersReducedMotion) {
    gsap.set(targets, { autoAlpha: 1, y: 0 });
    return;
  }

  gsap.set(targets, { autoAlpha: 0, y: 0 });

  const io = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (!entry?.isIntersecting) return;

      gsap.to(targets, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        delay: 0.1,
        ease: "none",
        overwrite: true,
      });

      io.disconnect();
    },
    {
      root: null,
      rootMargin: "0px 0px -20% 0px",
      threshold: 0,
    },
  );

  io.observe(footer);

  return () => {
    io.disconnect();
  };
};
